<i #helpPopup class="question circle icon" title=""></i>
@if (description) {
<div class="help-doc ui popup transition">
  <div class="header">{{ "description" | transloco }}</div>
  <div class="content">{{ description.desc }}</div>
  <div class="header">{{ "number-of-arguments" | transloco }}</div>
  <div class="content">{{ description.numArgs }}</div>
  <div class="header">{{ "input" | transloco }}</div>
  <div class="content">{{ description.input }}</div>
</div>
}
